var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-select',{ref:"fileSelect",attrs:{"accept":_vm.accept,"multiple":_vm.multiple},on:{"onFileSelect":_vm.fileSelectHandle}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }